import { render, staticRenderFns } from "./CptCodesDataTable.vue?vue&type=template&id=43866284&scoped=true&"
import script from "./CptCodesDataTable.vue?vue&type=script&lang=js&"
export * from "./CptCodesDataTable.vue?vue&type=script&lang=js&"
import style0 from "./CptCodesDataTable.vue?vue&type=style&index=0&id=43866284&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43866284",
  null
  
)

export default component.exports